import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import campaignReducer from './reducers/Campaign/campaignSlice';
import campaignRequestReducer from './reducers/CampaignRequest/campaignRequestSlice';
import authReducer from './reducers/Auth/authSlice';
import alertReducer from './reducers/Alert/alertSlice';
import bannerReducer from './reducers/Partner/Banner/bannerSlice';
import registryReducer from './reducers/Registry/Registry';
import requestsReducer from './reducers/Partner/Requests/requestSlice';
import partnerServiceReducer from './reducers/Partner/PartnerService/partnerServiceSlice';
import imageReducer from './reducers/images/imageSlice';
import partnerCampaignReducer from './reducers/Partner/Campaign/partnerCampaignSlice';
import sliderReducer from './reducers/slider/index';

export function makeStore() {
  return configureStore({
    reducer: {
      campaign: campaignReducer,
      auth: authReducer,
      campaignRequest: campaignRequestReducer,
      alert: alertReducer,
      banner: bannerReducer,
      registry: registryReducer,
      requests: requestsReducer,
      partnerService: partnerServiceReducer,
      images: imageReducer,
      partnerCampaign: partnerCampaignReducer,
      slider: sliderReducer,
    },
    devTools: process.env.NODE_ENV === 'development',
  });
}

const store = makeStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

export default store;
